import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { UserService } from './services/user.service';
import { ShaService } from './services/sha.service';
import { NgClass } from '@angular/common';

import { AppComponent } from './app.component';
import { routes } from './app.routes';

import { UserGuard } from './guards/user.guard';
import { SuperUserGuard } from './guards/superUser.guard';
import { AdminGuard } from './guards/admin.guard';
import { PublisherGuard } from './guards/publisher.guard';
import { AllGuard } from './guards/all.guard';
import { LoginComponent } from './login/login.component';
import { AppRoutingModule } from './app.routes';
import { AuthModule } from './auth.module';
import { UserListComponent } from './userList/user.list.component';

import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { PublisherListComponent } from './publisherList/publisher.list.component';
import { PublisherDetailComponent } from './publisherDetail/publisher.detail.component';
import { PublisherUserComponent } from './publisherUser/publisher.user.component';
import { UserDetailComponent } from './userDetail/user.detail.component';
import { UserNewComponent } from './userNew/user.new.component';
import { UserUpdateComponent } from './userUpdate/user.update.component';
import { PublisherUpdateComponent } from './publisherUpdate/publisher.update.component';
import { PublisherNewComponent } from './publisherNew/publisher.new.component';

import { FilterVersionsOfMedia } from './pipes/filterVersionsOfMedia';

import { ModalModule } from 'angular2-modal';
import { BootstrapModalModule } from 'angular2-modal/plugins/bootstrap';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { TableTemplateComponent } from './tableTemplate/table.template.component';
import { NgTableComponent } from './tableModel/ng-table.component';
import { NgTableFilteringDirective } from './tableModel/ng-table-filtering.directive';
import { NgTablePagingDirective } from './tableModel/ng-table-paging.directive';
import { NgTableSortingDirective } from './tableModel/ng-table-sorting.directive';
import { PublisherMediaComponent } from './publisherMedia/publisher.media.component';
import { MediaNewComponent } from './mediaNew/media.new.component';
import { MediaDetailComponent } from './mediaDetail/media.detail.component';
import { MediaUpdateComponent } from './mediaUpdate/media.update.component';
import { MediaVersionComponent } from './mediaVersion/media.version.component';
import { VersionDetailComponent } from './versionDetail/version.detail.component';
import { VersionNewComponent } from './versionNew/version.new.component';
import { LogListComponent } from './log/log.list.component';
import { UserStatComponent } from './userStat/user.stat.component';
import { MediaStatComponent } from './mediaStat/media.stat.component';
import { FileUploadModule } from 'ng2-file-upload';
import { MediaUploadComponent } from './mediaUpload/media.upload.component';
import { GridComponent } from './grid/grid.component';
import { VersionOrganisationUnitComponent } from './versionOrganisationUnit/version.organisation.unit.component';
import { SoftwareComponent } from './software/software.component';
import { MediaModal } from './services/media.modal';
import { StreamingComponent } from './streaming/streaming.component';
import { BlacklistComponent } from './blacklist/blacklist.component';

import { PaginationModule } from 'ngx-bootstrap/pagination'

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PublisherListComponent,
    UserListComponent,
    PublisherDetailComponent,
    PublisherUserComponent,
    UserDetailComponent,
    UserNewComponent,
    UserUpdateComponent,
    PublisherNewComponent,
    PublisherUpdateComponent,
    TableTemplateComponent,
    NgTableComponent,
    NgTableFilteringDirective,
    NgTablePagingDirective,
    NgTableSortingDirective,
    PublisherMediaComponent,
    MediaNewComponent,
    MediaUpdateComponent,
    MediaDetailComponent,
    MediaVersionComponent,
    VersionDetailComponent,
    VersionNewComponent,
    LogListComponent,
    UserStatComponent,
    MediaStatComponent,
    MediaUploadComponent,
    GridComponent,
    VersionOrganisationUnitComponent,
    SoftwareComponent,
    MediaModal,
    StreamingComponent,
    BlacklistComponent,
    FilterVersionsOfMedia
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    AuthModule,
    FileUploadModule,
    ModalModule.forRoot(),
    BootstrapModalModule,
    PaginationModule.forRoot()

  ],
  providers: [UserService, AdminGuard, UserGuard, SuperUserGuard, PublisherGuard, AllGuard],
  bootstrap: [AppComponent],
  entryComponents: [ MediaModal ]
})
export class AppModule { }

// Compile and launch the module
platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/app.module.ts